import { Card } from '@/components/ui/card';
import { Stat } from '@/components/ui/stat';
import { cn } from '@/lib/utils';
import { Status } from '@/types';

interface StatusCardProps {
  type: Status;
  count: number;
  bgColor: string;
  dotColor: string;
  textColor: string;
}

export function StatusCard({ type, count, bgColor, dotColor, textColor }: StatusCardProps) {
  return (
    <div className={cn("flex-1 pt-1 pb-1 pl-2 pr-2 rounded-[6px] flex flex-col justify-between", bgColor)}>
      <div className="flex items-center gap-[4px]">
        <div className={cn("w-1.5 h-1.5 rounded-full", dotColor)} />
        <span className="paragraph-11 text-black capitalize">{type}</span>
      </div>
      <span className={cn("heading-7", textColor)}>
        {count} unit{count > 1 ? 's' : ''}
      </span>
    </div>
  );
}